import { useAuth } from "hooks/auth";
import useSWR, { SWRResponse } from "swr";
import { Token } from "types/general";
import { getEnvVariable } from "utilities/env";

export const useTokens = () => {
  const { fetcher } = useAuth();

  const createToken = async (
    adminId: string,
    values: { apiKey: Pick<Token, "name" | "expirationDate"> },
  ) => {
    const response = await fetcher(
      `${getEnvVariable("REACT_APP_API_URL")}/admin/${adminId}/api-key`,
      {
        body: JSON.stringify(values),
        headers: { "Content-Type": "application/json" },
        method: "post",
      },
    );
    const data = await response.json();

    if (response.ok) {
      return data;
    } else {
      throw data;
    }
  };

  const editToken = async (
    adminId: string,
    tokenId: string,
    values: { apiKey: Pick<Token, "name" | "expirationDate"> },
  ) => {
    const response = await fetcher(
      `${getEnvVariable("REACT_APP_API_URL")}/admin/${adminId}/api-key/${tokenId}`,
      {
        body: JSON.stringify(values),
        headers: { "Content-Type": "application/json" },
        method: "put",
      },
    );

    if (response.status === 204) {
      return true;
    } else {
      throw await response.json();
    }
  };

  const deleteToken = async (adminId: string, tokenId: string) => {
    const response = await fetcher(
      `${getEnvVariable("REACT_APP_API_URL")}/admin/${adminId}/api-key/${tokenId}`,
      {
        method: "delete",
      },
    );

    if (response.ok) {
      return true;
    } else {
      throw await response.json();
    }
  };

  const useTokensList = (
    adminId?: string,
  ): SWRResponse<{
    items: Token[];
    total: { all: number; filtered: number };
  }> => {
    return useSWR(
      () =>
        !!adminId
          ? `${getEnvVariable("REACT_APP_API_URL")}/admin/${adminId}/api-key`
          : null,
      fetcher,
    );
  };
  return {
    createToken,
    deleteToken,
    editToken,
    useTokensList,
  };
};
